export const userTableDetailCols = [
  { label: '日期', prop: 'orderDate' },
  { label: '订单号', prop: 'orderCode' },
  { label: '销售额(￥)', prop: 'productAmount' },
  { label: '销售产品款式数量', prop: 'styleName', slotName: 'styleNameSlot' }
]
